<template>
  <PlainAddress
    ref="plain"
    :input-data="inputData"
    :value="storedValue"
    :form-name="formName"
    :gtm-form-name="gtmFormName"
    @input="onInput"
    @valid-change="onValidChange"
  />
</template>

<script>
import formGtm from '@/mixins/formGtm';
import PlainAddress from '@/components/newForms/PlainAddress.vue';

export default {
  name: 'UlAddress',
  components: { PlainAddress },
  mixins: [formGtm],
  props: {
    inputData: { type: Object, required: true },
    stepId: { type: Number, required: true }
  },
  data() {
    return { isValid: false };
  },
  computed: {
    storedValue() {
      return (
        this.$store.getters['dynamicForms/responses']?.[this.formName]?.[this.inputData.id] || ''
      );
    }
  },
  created() {
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, this.handleValidate);
    this.$eventHub.$on(
      `resetValidationInput_${this.inputData.id}_${this.stepId}`,
      this.handleReset
    );
  },
  destroyed() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`, this.handleValidate);
    this.$eventHub.$off(
      `resetValidationInput_${this.inputData.id}_${this.stepId}`,
      this.handleReset
    );
  },
  methods: {
    onInput(value) {
      this.$store.dispatch('dynamicForms/updateResponse', {
        id: this.inputData.id,
        value,
        formName: this.formName
      });
      this.$emit('update:value');
    },
    onValidChange(isValid) {
      this.isValid = isValid;
    },
    handleValidate() {
      this.$refs.plain?.validate();
      this.$store.commit('dynamicForms/updateValidation', {
        id: this.inputData.id,
        value: this.isValid,
        formName: this.formName
      });
    },
    handleReset() {
      this.$refs.plain?.reset();
    }
  }
};
</script>
